import * as angular from "angular";
import * as _ from "lodash";
import { Filter } from "../../models/filter.model";
import { DialogUtils } from "../../helper/dialog.helper";
import { OrganisationUserDataProvider } from "../../data-provider/organisation-user.dp";
import { Utils } from "../../helper/utils.helper";
import { Organisation } from "../../models/organisation.model";
import { CampaignDataProvider } from "../../data-provider/campaign.dp";
import { User } from "../../models/user.model";
import { UserDataProvider } from "../../data-provider/user.dp";
let OrganisationUserListComponent = {
    selector: "vcOrganisationUserList",
    templateUrl:
        "/angular/components/organisation-user/organisation-user-list.component.html",
    bindings: {
        filter: "=?",
        columns: "=?",
    },
    controller: class OrganisationUserListController {
        // * bindings for typescript compiler *
        public filter?: Filter;
        public columns?: any;
        // ************************************

        private $scope: any;
        private organisationUserDataProvider: OrganisationUserDataProvider;
        private dialog: DialogUtils;

        private readonly utils: Utils;
        public filterTimeout: any = null;
        public previousFilter?: any;
        private activeOrganisation: Organisation;
        public signedInUser: User;
        constructor(
            $scope: any,
            CampaignDataProvider: CampaignDataProvider,
            OrganisationUserDataProvider: OrganisationUserDataProvider,
            UserDataProvider: UserDataProvider,
            DialogUtils: DialogUtils,
            Utils: Utils
        ) {
            this.$scope = $scope;
            this.organisationUserDataProvider = OrganisationUserDataProvider;
            this.dialog = DialogUtils;
            this.utils = Utils;

            this.signedInUser = UserDataProvider.getActiveUser();
            CampaignDataProvider.getOrganisations().then((organisation) => {
                this.activeOrganisation = organisation;
            });
        }

        $onInit() {
            this.organisationUserDataProvider.getCustomFieldColumns();

            this.$scope.$watch(
                () => this.filter,
                (newValue, oldValue) => {
                    if (
                        !this.previousFilter ||
                        (newValue &&
                            !angular.equals(
                                newValue.nonEmptyValues(),
                                oldValue.nonEmptyValues()
                            )) ||
                        (Object.keys(newValue).length &&
                            !Object.keys(oldValue).length)
                    ) {
                        this.previousFilter = _.cloneDeep(newValue);
                        if (this.filterTimeout) {
                            clearTimeout(this.filterTimeout);
                        }
                        this.filterTimeout = setTimeout(() => {
                            this.loadData(this.filter);
                        }, 500);
                    }
                },
                true
            );
        }

        loadData(filter, last?): void {
            this.organisationUserDataProvider.getAllUsers(filter, last);
        }

        scrollLoad(filter, offset): void {
            if (!this.organisationUserDataProvider.scrollLoading) {
                this.organisationUserDataProvider.getAllUsers(
                    filter,
                    offset,
                    true
                );
            }
        }

        openViewUserDialog(user, ev): void {
            this.dialog.show({
                component: "vc-view-organisation-user",
                targetEvent: ev,
                size: "large",
                scope: this.$scope,
                ariaLabel: "View Person",
                locals: {
                    selectedUser: user,
                    selectedUserId: null,
                    editable: true,
                    onUserDeleted: this.utils.bindFunction(() => {
                        this.organisationUserDataProvider.clearAll();
                        this.loadData(this.filter);
                    }, this),
                    onUserUpdated: this.utils.bindFunction(() => {
                        this.organisationUserDataProvider.clearAll();
                        this.loadData(this.filter);
                    }, this),
                },
            });
        }
        openEditUserDialog(user: User, event: any): void {
            this.dialog
                .show({
                    component: "vc-leader-user",
                    targetEvent: event,
                    clickOutsideToClose: false,
                    scope: this.$scope,
                    size: "large",
                    locals: {
                        organisation: this.activeOrganisation,
                        selectedUser: user,
                    },
                })
                .then((data: object) => {
                    this.organisationUserDataProvider.clearAll();
                    this.loadData(this.filter);
                });
        }
        canEditUser(user: User): boolean {
            const userPermission = user.permission.permissionid;
            const signedInUser = this.signedInUser;
            const signedInPermission =
                signedInUser.account_type == "ADMIN"
                    ? 8
                    : signedInUser.permission.permissionid;

            return (
                userPermission !== 8 &&
                ([8, 9].includes(signedInPermission) ||
                    (signedInPermission === 10 &&
                        ![9, 10].includes(userPermission)))
            );
        }
    },
};

angular
    .module("organisationUser")
    .component(
        OrganisationUserListComponent.selector,
        OrganisationUserListComponent
    );
